export default __webpack_public_path__ + "static/media/meta_titles_and_descriptions.9cbd8616.svg";